import SplitWithImage from './SplitWithImage'
export default SplitWithImage
